module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    staticClass: "chapter-title-corner-decorations",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-left",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_left.png"
    }
  })])]), _c('td', {
    staticClass: "chapter-title-corner-decoration-middle-column"
  }), _c('td', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-right",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_right.png"
    }
  })])])])])]), _c('div', {
    staticClass: "chapter-title"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-above",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_above.png"
    }
  })])]), _c('h1', {
    staticClass: "chapter-title"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('div', {
    staticClass: "chapter-title-decoration-below"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-below",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_below.png"
    }
  })])])]), _c('p', {
    staticClass: "first-in-chapter",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-chapter-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("“D")]), _vm._v("ante,” I said, looking")]), _vm._v(" over the plans he had given me. “This is so extensive. I mean, steel reinforced wall coverings, thicker glass...bullet-proofed glass for the windows...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Dante gave me his cute smile and a shrug as he took a sip of coffee at my Aunt Sookie’s Malibu Pad small kitchen table. It was Saturday morning, and Aunt Sookie was out this weekend at a yoga retreat. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Of course, Dante decided he wanted to have a yoga retreat of his own at the Pad, when he surprised me with a visit last night, showing up at the front door, with a bag full of groceries. I was still angry at him for what went down with River so Dante had been making it up. River knew I wasn’t exclusive with him, and Dante was already making his moves on me. Dante was a go-getter and have shown that when he wanted something or someone, like me, he would go after it without hesitation. River missed his chance, although I’ve given him several chances. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Now Dante was with me, smoothing things over with us, convincing me how much I meant to him. He sat me down at the living room sofa while he cooked up a full 3-course dinner.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("After dinner, he took my hand in his and led me to my bedroom where he made love to me all night, even working me into positions he said were yoga moves. It didn’t matter what they were, in the end, Dante had positioned and moved my body every which way to get me to experience the most mind-blowing orgasms I’ve ever had. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Too exhausted, I fell asleep in Dante’s arms, where he held me all night, kissing my temple, my forehead and cheeks while he gazed into my eyes. The way he looked at me, I felt like the most important person in the world, and the way he held onto me, I felt like he was trying to hold on to me forever. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("This morning, he surprised me again by making breakfast for me.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Summer,” Dante said, “I don’t know what your aunt has been feeding you, looking at the sorely lack of food you have in your pantry and fridge, you need to eat more proteins and gain more muscles,” he eyed me and said, “Not that I don’t love how your body is now, but I know you can get a stronger, more fit body than you have.” He kissed me before I bit into my breakfast. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Why are you suddenly interested in whipping my body more in shape?” I asked, taking a bite of the spinach, mushroom egg-white omelet he whipped up. “Oh, this is delicious,” I said. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Because, Baby,” Dante said, “I want to take care of you. I want you to be able to take care of yourself, too. By having a stronger body, you will be more capable of it.” He smiled, “Plus, I want you to be able to keep up with me...I have all kinds of things in mind that I want to do to you, and I want you to be awake while I do them. It’ll be much more enjoyable for both of us.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I pointed my fork at him and said after swallowing a mouthful of superfood salad. “This is so good,” I said. “And you, I knew you had an ulterior motive to get me into shape... and it has to do with sex.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Dante laughed. “You figured me out. Guilty as charged.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He looked down at my almost-empty dish and said, “I see you couldn’t stand my cooking. I’ll have to improve on seducing you with it.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I laughed, gulping down a mouthful of coffee. Even the coffee he made was delicious. “Is that what this is all about? Seducing me?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Dante took my hand in his before kissing my knuckles. “Everything I do is meant to seduce you, Summer.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It’s working,” I said. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He kept looking at me, his eyes soft with tender emotions. I’ve never seen Dante like this... almost vulnerable, not in charge, almost at a loss. Something was up, and my heart grew full as he kept kissing my hand. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Dante?” I asked. “Something wrong?” I leaned over to hug and kiss him. “You can talk to me about anything. You know that, right?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Dante gave my knuckles one last kiss before he dazzled me with his golden boy smile. “Just thinking how lucky I am to be with you, Summer. Out of all the guys who love you, I feel like I’ve won the prize being with you here today.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oh, Dante,” I hugged him close and took his face in both my hands before kissing him. “I’m the one who’s lucky. You can have any girl, but here you are with me.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“That’s because,” Dante said, kissing me back more passionately. “I’ve never felt anything before for anyone else, Summer.” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Your heart,” I said. “I’m so sorry about it. How did you get a mechanical heart? What happened?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Dante nodded. “I don’t even remember what happened. All I know was that I was in a terrible accident when I was a kid, and I woke up in some hospital in Europe with a new heart. Not human, but mechanical.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Wow, that’s stranger than fiction,” I said. “A mechanical heart...” I grinned. “So cool and amazing. You’re even cooler than I thought. You’re a real life steampunk/bionic man.” I lifted his black t-shirt to feel his chest. His pulse was at a steady beat as I moved my other hand down to gently stroke him under his boxers. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“So you think having a mechanical heart is cool?” Dante said, looking at me with hooded eyes. “What other part of mine do you find cool?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I glanced down briefly and said, “Well...I can’t seem to keep my hands off one part.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I’m glad you can’t keep your hands to yourself then,” Dante said. “But if you continue being all handsy with me, you will have to suffer the consequences.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oh, and what is that?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Dante suddenly stopped my hands from stroking him and reached over to lift me by the waist, carrying me to the sofa nearby. Instead of depositing me on the sofa, he bent me over face down, pushed down my pajama pants and palmed my butt before spreading me. Without hesitation, his now rock hard cock thrusted deep into me, pushing me forward. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I moaned, “Oh Dante, yes, I like how you are punishing me for being so handsy.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It’s the only punishment I have, reserved for you, Princess,” he said as he pushed into me again and again. His fingers rubbed on my core while he punished me some more before we both yelled out our climaxes.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Then he laid me out on the sofa, facing me as he kissed his way down from my mouth to my core. “I’ll never get tired of punishing my princess,” he groaned as he licked me.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("When I came again, Dante laid down next to me and kissed me. “You’re the only person who knows about my heart being mechanical. Other than my father. How did you know?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Your heartbeat,” I said. “I was just testing it out now. Even when you’re aroused,” I smiled, looking down at his still hard cock, “Your heartbeat was the same as before, while everything else about you was clearly turned on.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Dante laughed. “You’re amazing, Summer. So smart. Nobody ever noticed.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I sure hope not,” I said. “I mean I sure hope no one tried arousing you like I did just to see how your heartbeat was like.”  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Nobody ever got that close to me to find out,” Dante admitted. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I reached out a finger to touch his nose, “Then it’ll be our little secret,” I said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Dante beamed then, lighting up his entire face like a little boy who was given the very toy he wanted and wished for from Santa for Christmas. “I’d like that, Summer,” he said. “I’d love to be able to share the most intimate part of me with you.” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Dante,” I grinned, touching his cheeks with my palm, “Thank you for trusting me with your secrets.” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He kissed me then and kept kissing me until a phone call caused him to break off. He looked down at his phone and sighed. “Looks like I have to get this.”  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I got up and walked into my room, finally changing out of my pajamas. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("When I turned around, Dante was standing at the doorway, watching me change, his face still and full of desire. “I can’t stop wanting you,” he said. “Even when I shouldn’t.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What’s the matter?” I asked, rushing over to him and hugging him tightly. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Summer,” Dante said, “I wish I could tell you.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“But if you did, you’ll have to kill me,” I joked. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Dante gave me a small smile then and said, “Something like that.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Okay,” I said. “I won’t pry. But know that I’m here for you no matter what. You mean so much to me, Dante.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Dante hugged me tightly and whispered into my ear. “You mean so much to me, too, Summer in such a short period of time. You have no idea how much.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 2 ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-269ca73a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c004.vue
// module id = 69
// module chunks = 0